export class BaseTooltipHelper {
    constructor() {
        this.activeTriggerSet = {
            mark: new Set,
            dimension: new Set,
            group: new Set
        }, this.ignoreTriggerSet = {
            mark: new Set,
            dimension: new Set,
            group: new Set
        };
    }
}
//# sourceMappingURL=tooltip-helper.js.map
